import * as THREE from 'three'

/**
 * 合并多个包围盒，空数组返回零尺寸包围盒。
 *
 * @param boxes - 待合并的包围盒数组
 * @returns 能容纳全部输入的并集 Box3；输入为空返回 min/max 都为原点的零盒
 */
export function mergeBoundingBoxes(boxes: THREE.Box3[]): THREE.Box3 {
  if (boxes.length === 0) {
    return new THREE.Box3(new THREE.Vector3(), new THREE.Vector3())
  }
  const merged = new THREE.Box3()
  for (const box of boxes) {
    merged.union(box)
  }
  return merged
}

/**
 * NDC 坐标转世界空间射线。
 *
 * @param ndc - 归一化设备坐标 [-1, 1]
 * @param camera - 用于构造射线的相机
 * @returns 从相机出发经过指定 NDC 的世界空间射线副本
 */
export function ndcToRay(ndc: THREE.Vector2, camera: THREE.Camera): THREE.Ray {
  const raycaster = new THREE.Raycaster()
  raycaster.setFromCamera(ndc, camera)
  return raycaster.ray.clone()
}
